import {useEffect, useState} from 'react';

export const ShowContentInTabs = ({tabs, children}) => {
  const [tabIndex, setTabIndex] = useState(0);
  useEffect(() => {
    setTabIndex(0); // reset when new tabs come, because the amount may not be the same
  }, [tabs]);

  return (
    <>
      <div className='flex justify-between my-0'>
        {tabs.map((val, index) => (
          <div
            className={`grow text-center ${
              tabIndex === index ? 'font-bold text-black select-none' : ''
            }`}
            style={{
              backgroundColor: tabIndex === index ? '#e0f2f1' : '',
              border: tabIndex === index ? '2px solid green' : '1px solid #e0e0e0',
              borderTop: tabIndex === index ? '2px solid green' : '1px solid #e0e0e0',
              borderRight: index < tabs.length - 1 ? '1px solid #e0e0e0' : '',
              cursor: 'pointer'
            }}
            role='button'
            alt='Tab Button for Subwoofer Wiring Diagrams'
            aria-current='page'
            onClick={() => setTabIndex(index)}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#f5f5f5')}
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = tabIndex === index ? '#e0f2f1' : '')
            }
            key={index}>
            {val}
          </div>
        ))}
      </div>
      <div className='border border-1 border-top-0'>{children(tabIndex)}</div>
    </>
  );
};
